import { FC, ReactNode } from 'react';
import { cx } from '@/utils/cx';

export type CardLabelProps = {
  children: ReactNode;
  className?: string;
};

export const CardLabel: FC<CardLabelProps> = ({ children, className }) => (
  <div className={cx('mb-4 mt-6 text-sm/6 font-medium', className)}>
    {children}
  </div>
);
